<template>
  <div class="intercomadvantage">
    <div class="header">
      <div class="title">楼宇对讲优势</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in intercomadvantageList" :key="item.id">
          <div class="right">
            <img :src="item.logo" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import intercomadvantage1 from "../../../../assets/programme/intercomadvantage1.png";
import intercomadvantage2 from "../../../../assets/programme/intercomadvantage2.png";
import intercomadvantage3 from "../../../../assets/programme/intercomadvantage3.png";
import intercomadvantage4 from "../../../../assets/programme/intercomadvantage4.png";
import intercomadvantage5 from "../../../../assets/programme/intercomadvantage5.png";
import intercomadvantage6 from "../../../../assets/programme/intercomadvantage6.png";

export default {
  setup() {
    return reactive({
      intercomadvantageList: [
        {
          id: 1,
          title: "可视性好",
          text: "主人通过对讲设备与来访者进行双向可视通话，通过来访者的声音或图像确认来访者的身份",
          logo: intercomadvantage1,
        },
        {
          id: 2,
          title: "成本低",
          text: "采用现代化的计算机技术、传感技术、传输技术、网络技术、自动控制技术等各种先进技术来提高效率、降低损耗、节约成本",
          logo: intercomadvantage2,
        },
        {
          id: 3,
          title: "安全性高",
          text: "住户可遥控开启防盗门，各单元梯口访客再通过对讲主机呼叫住户，对方同意后方可进入楼内，从而限制了非法人员进入。",
          logo: intercomadvantage3,
        },
        {
          id: 4,
          title: "效率高",
          text: "支持多种开门方式；支持防拆报警；支持快速人脸识别及双向对讲",
          logo: intercomadvantage4,
        },
        {
          id: 5,
          title: "功能齐全",
          text: "总控中心的管理员总机、楼宇出入口的对讲主机、电控锁、闭门器及用户家中的可视对讲分机通过专用网络组成",
          logo: intercomadvantage5,
        },
        {
          id: 6,
          title: "方便快捷",
          text: "可扩展人口信息大数据平台、人工智能新媒体平台；人脸数据，开门记录，访客抓拍留影及存储",
          logo: intercomadvantage6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.intercomadvantage {
  width: 92vw;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  margin-top: 16px;
}
.body .list {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.body .list .item {
  width: 162px;
  display: flex;
  margin-bottom: 40px;
  text-align: center;
}
.body .list .item .right img {
  width: 36px;
}
.body .list .item .right .title {
  font-size: 14px;
  margin-top: 12px;
  font-weight: 600;
}
.body .list .item .right .text {
  font-size: 12px;
  color: #495a6c;
  margin-top: 8px;
}
</style>
